import Check from '@/views/Check/Check'

const routes = {
  path: '/check',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/check',
      name: 'Marcar ponto',
      component: Check,
    },
  ],
}

export default routes
